import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Select,
  Text,
  FormErrorMessage,
  Alert,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { genReports } from "../../redux/slices/reportsSlice";
import { reportsSchema } from "../../utils/formValidationSchema";

const ReportPanel = ({ setLoading }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState("");

  const initialValues = {
    eventName: "select",
    startDate: "",
    endDate: "",
    membershipType: "",
    eventType: "",
    // attendanceType: "",
    // amount:"",
  };

  const allEvents = useSelector(
    (state) => state.eventRegistration?.allEvents || []
  );

  useEffect(() => {}, [allEvents]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const formData = {
        eventName: values.eventName,
        eventType: values.eventType,
        startDate: values.startDate,
        endDate: values.endDate,
        membershipType: values.membershipType,
        // attendanceType: values.attendanceType,
        // amount: values.amount,
      };

      const response = await dispatch(genReports(formData));
      if (!response.message) {
        setError("");
        setLoading(false);
      } else {
        setLoading(false);
        setError(
          response?.responseDescription || "Request failed. Please try again "
        );
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Text color={"brand.primary"} fontSize={"16px"}>
        Select any option below to generate report
      </Text>
      {error ? (
        <Alert status="error" className="mt-3">
          <AlertIcon />
          <AlertTitle>{error}</AlertTitle>
        </Alert>
      ) : (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={reportsSchema}
          onSubmit={(values) => handleSubmit(values)}
        >
          {({
            errors,
            touched,
            values,
            handleBlur,
            handleChange,
            submitForm,
          }) => (
            <Grid
              as={Form}
              templateColumns={[
                "repeat(1, 1fr)",
                "repeat(2, 1fr)",
                "repeat(2, 1fr)",
                "repeat(3, 1fr)",
              ]}
              gap={4}
              py={4}
            >
              <GridItem>
                <FormControl isInvalid={errors.eventName && touched.eventName}>
                  <FormLabel htmlFor="eventName">Event Name</FormLabel>
                  <Select
                    placeholder={
                      allEvents.length === 0
                        ? "No events available"
                        : "Select name"
                    }
                    bg={"#FAFAFA"}
                    name="eventName"
                    border={"0.5px solid #8A8C8E"}
                    _placeholder={{ color: "#8A8C8E" }}
                    focusBorderColor="0.5px solid #8A8C8E"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      if (e.target.value) {
                        submitForm();
                      }
                    }}
                    value={values?.eventName}
                    disabled={!allEvents || allEvents.length === 0} // Disable if no data
                  >
                    {allEvents && allEvents.length > 0 ? (
                      allEvents.map((event) => (
                        <option key={event?.id} value={event?.name}>
                          {event?.name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No events available
                      </option>
                    )}
                  </Select>
                  {touched.eventName && errors.eventName && (
                    <FormErrorMessage>{errors.eventName}</FormErrorMessage>
                  )}
                </FormControl>
              </GridItem>
            </Grid>
          )}
        </Formik>
      )}
    </Box>
  );
};

export default ReportPanel;
